import { useContext } from "react"
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Context } from "../Context"
import { PermissionData } from "../Context"
import * as XLSX from "xlsx"
import { BASE_URL } from "./defaultValues";
import constant from "./constant";
import { CountryCodeReturnType, ModifiedDataForContactLensProps, TProductType } from "./interface";

export const getDropdownValue = (constant: any, ind: any) => {
    let temp: any = {
        "value": 0,
        "label": '',
    }
    constant.map((item: any) => {
        if (item.value === ind) {
            temp = item
            temp.value = item.value
            temp.label = item.label
        }
    })
    return temp
}
export const getUniqueObj = (data: any, id: string, compareId: string) => {
    let tempObj: any
    data && data.map((item: any) => {
        if (item[id] === compareId) {
            tempObj = item
        }
    })
    return tempObj
}
export const getDropdown = (response: [], name: string) => {
    let dropdown: any = []
    response && response.map((value: any) => {
        dropdown.push({
            "value": value.id,
            "label": value[name],
        }
        )
    })
    return dropdown
}

export const handleNumber = (e: any) => {
    const inputValue = e.target.value;
    const digitsOnly = inputValue.replace(/\D/g, '');
    if (digitsOnly.length <= 10) {
        return digitsOnly
    }
}

export const checkPermissionsInArray = (code: string) => {
    const [userPermission, setUserPermission] = useContext<string[]>(PermissionData);
    return userPermission?.includes(code)
    // const store_admin_scope = localStorage.getItem("scope")
    // if(store_admin_scope !== "3"){
    // }else{
    //     return true
    // }
};

export const findConstantLabel = (constant: { label: string, value: string | number }[], value: string | number) => {
    const warranty: any = constant.find((item: any) => item.value === value);
    return warranty ? warranty.label : 'Unknown';
}

export const numberWithCommas = (number: number, fractionDigits?: number) => {
    if (typeof fractionDigits === 'number') {
        return number.toLocaleString('en-IN', {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        });
    }
    return number.toLocaleString('en-IN'); // Use 'en-IN' for the Indian numbering system
};

export const convertToCommaFormat = (value: string | number): string => {
    return numberWithCommas(Number(Number(value)?.toFixed(2))) || ''
}

export const handleReportDownload = async (response: any, name: string, report_format: number, report_heading: string) => {
    let path = response
    let fullPath = `${BASE_URL}${path}`
    let cleanPAth = fullPath.replace(/api\/\.\//, '')
    let fileName = cleanPAth.substring(cleanPAth.lastIndexOf("/") + 1)
    // window.open(`${cleanPAth}`, '_blank')

    if (report_format === constant?.DailyReportFormat[0].value) {

        // convert the data to json
        const xlsResponse = await fetch(cleanPAth);
        const xlsData = await xlsResponse.arrayBuffer();

        // Convert XLS data to JSON
        const workbook = XLSX.read(new Uint8Array(xlsData), { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        generatePdfHeader(jsonData, 4, name, report_heading)
    }

    if (report_format === constant?.DailyReportFormat[1].value) {

        setTimeout(() => {
            fetch(`${cleanPAth}`).then((response) => {
                response.blob().then((blob) => {

                    // Creating new object of PDF file
                    const fileURL = window.URL.createObjectURL(blob);

                    // Setting various property values
                    let alink = document.createElement("a");
                    alink.href = fileURL;
                    alink.download = `${fileName}`;
                    alink.click();
                });
            });
        }, 2000);
    }
}

export const convertJsonToExcel = (jsonData: any, filename: any) => {
    const ws = XLSX.utils.json_to_sheet(jsonData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
    XLSX.writeFile(wb, `${filename}.xlsx`);
};

export const convertArrayToKeyValue = (array: []) => {
    return array.map(size => ({
        label: size,
        value: size
    }));
}

// for generate pdf

const addTotalLine = (data: any, pdfName: string) => {
    if (pdfName === 'sales-return-report') {
        let totalGrossSales = data[data?.length - 1]["S.No."]
        let totalDiscount = data[data?.length - 1]["Credit Note No."]
        let totalNetSales = data[data?.length - 1]["Credit Note Date"]
        let totalSalesExcludingGST = data[data?.length - 1]["Credit Note Amount"]
        let totalGST = data[data?.length - 1]["Original Invoice No."]

        data.pop()
        const newObject = {
            "id": data[data?.length - 1],
            "S.No.": data[data?.length],
            "Credit Note No.": "",
            "Credit Note Date": "",
            "Credit Note Amount": "",
            "Original Invoice No.": "",
            "Original Invoice Date": "",
            "Customer Name": "",
            "Company Name": "",
            "GST No.": "",
            "Barcode": "",
            "Gross Sales": totalGrossSales,
            "Discount": totalDiscount,
            "Net Sales": totalNetSales,
            "Sales Excluding GST": totalSalesExcludingGST,
            "GST": totalGST,
            "Product Amount": "",
            "Additional Charge": "",
            "Loyalty Points Charges": "",
            "Cost of Good Sold (EX GST)": ""
        }

        // Add the new object to the end of the array
        data.push(newObject);

    }
    return data
}

export const generatePdfHeader = (data: any, countOfRowHaveData: number, pdfName: string, report_heading: string) => {
    if (data) {
        if (data && data.length >= countOfRowHaveData) {
            const headerRow = data[countOfRowHaveData - 1]; // Get the fifth-to-last row
            const headerValues = Object.values(headerRow);
            generatePdfData(data, headerValues, countOfRowHaveData, pdfName, report_heading)
        }
    }
}

const generatePdfData = (data: any, header: any, countOfRowHaveData: number, pdfName: string, report_heading: string) => {
    if (!data) return;

    const dataLength = data.length;

    if (dataLength === countOfRowHaveData) {
        return;
    }

    const pdfData = data.slice(countOfRowHaveData).map((row: any, index: number) => {
        const headerValues = Object.values(row);
        const obj: any = { id: index + 1 };
        header.forEach((key: any, j: number) => {
            obj[key] = headerValues[j];
        });
        return obj;
    });

    const getValueFromString = (valueArr: any, name: string) => {
        let lastIndex = valueArr.lastIndexOf([name]); // last occurrence of space
        let value = valueArr.substring(lastIndex + 1);
        return value
    }

    // (0,1,2) are the row in which storeName , date in the xlsx last 0 add to access the data form array
    // ":","n","m", is take to separate the string it take from xlsx 
    pdfData.reportHeading = report_heading ? report_heading : ''
    pdfData.storeName = getValueFromString(Object?.values(data[0])[0], ":")
    pdfData.reportGeneratedOn = ((getValueFromString(Object?.values(data[1])[0], "n"))?.split(" ")[1]);
    pdfData.reportIsFrom = getValueFromString(Object?.values(data[2])[0], "m")


    generatePDF(header, addTotalLine(pdfData, pdfName), pdfName);
};

const createHeaders = (keys: string[]) => {
    const result = keys.map(key => {
        return {
            id: key,
            name: key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').trim(),
            prompt: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '),
            width: 65,
            align: "center",
            padding: 0
        };
    });
    return result;
};

const generatePDF = (header: any[], pdfData: any, pdfName: string) => {
    const headers: any[] = createHeaders(header);

    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape", format: 'a4' });
    const data = pdfData?.map((entry: any) => ({
        ...entry,
        id: entry.id.toString() // Convert id to string explicitly
    }));

    // Add heading
    const heading = `${pdfData?.reportHeading}`
    doc.setFontSize(20);
    doc.text(heading, 100, 10);

    // Add Store Name
    const report_store_name = `${pdfData?.storeName}`;
    doc.setFontSize(10);
    doc.text(`Store Name`, 15, 15);
    doc.setTextColor(80, 90, 111);
    doc.text(`${report_store_name}`, 35, 15);


    // Add date
    const report_date_to = `${pdfData?.reportGeneratedOn}`;
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`Report Generated on`, 15, 20);
    doc.setTextColor(80, 90, 111);
    doc.text(`${report_date_to}`, 50, 20);


    const report_date_from = ` 2024-02-21 to 2024-02-21`;
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`Report is from`, 15, 25);
    doc.setTextColor(80, 90, 111);
    doc.text(`${report_date_from}`, 40, 25);



    (doc as any).autoTable({
        head: [headers.map(header => header.prompt)],
        body: data.map((row: any) => headers.map(header => row[header.id])),
        startY: 30,// Adjust starting Y position as needed,
    });
    doc.save(`${pdfName}.pdf`);
};

// generate pdf code end here
export const getParams = (path: string) => {
    let urlParams = new URLSearchParams(location.search);
    let typeValue: any = urlParams?.get(path)
    return typeValue
}

export const isActiveQuery = (queryKey: any, queryValue: any) => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams?.get(queryKey) == queryValue;
};

export const modifiedDataForContactLens = ({ data, filterCondition }: ModifiedDataForContactLensProps) => {
    return data?.filter(filterCondition) || []
}


export const getContactLensType = () => {
    const storedValue: any = localStorage.getItem('isContactLensProduct') === 'true'
    if (storedValue) {
        try {
            return JSON.parse(storedValue);
        } catch (error) {
            console.error('Error parsing localStorage value:', error);
            return false;
        }
    }
    return false;
}
export const renderOptions = (
    options: any[],
    selectedValue: any,
    property: string,
    handleClick: (productId: any) => void,
    isPeriod?: boolean
) => {
    return options?.map((option: any, index: number) => {
        const isSelected = selectedValue === option[property];
        return (
            <p
                className={`glass-div cursor-pointer fw-700 fs-md-18 fs-12 my-auto ${isSelected ? 'glass-div-selected' : ''
                    }`}
                key={`glass${index}`}
                onClick={() => handleClick(option.product_id)}
            >
                {isPeriod ? getDropdownValue(constant.PERIOD_USE, option[property])?.label : option[property]}
            </p>
        );
    });
};
export const removeNewlines = (input: string): string => {
    return input?.replace(/\n/g, '');
};


export const handleInventoryDownload = async (response: any, name?: string,) => {
    let path = response
    let fullPath = `${path}`
    let cleanPAth = fullPath.replace(/api\/\.\//, '')
    let fileName = name ? `${name}${cleanPAth.lastIndexOf("/") + 1}` : cleanPAth.substring(cleanPAth.lastIndexOf("/") + 1)

    setTimeout(() => {
        fetch(`${cleanPAth}`).then((response) => {
            response.blob().then((blob) => {

                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);

                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = `${fileName}`;
                alink.click();
            });
        });
    }, 2000);
}

export const calculateDeliveryDate = (estimatedDeliveryDays: number): string => {
    const currentDate = new Date();
    const deliveryDate = new Date(currentDate);

    deliveryDate.setDate(currentDate.getDate() + estimatedDeliveryDays || 0);

    return deliveryDate.toISOString().split("T")[0];
};

// Function to convert the header into excel (use in download the GP Excel)
export const downloadExcelFileWithHeaders = (fileName: string, headers: string[]) => {
    // Using the passed headers
    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};
// end

// function to know the store is kuwait region or not
export const isStoreKuwaitRegion = (): boolean => {
    // Retrieve region code from localStorage and convert it to a number
    const regionCode = Number(localStorage.getItem('store_region'))

    return regionCode === constant.STORE_REGION.KUWAIT
}
//end

//function to know the store is regular gst type or not
export const isRegularGstStore=():boolean=>{
    // Retrieve gst type from localStorage and convert it to a number
    const storeGstType =  Number(localStorage.getItem('store_gst_type'));
    return storeGstType === constant.GST_DETAILS.REGULAR
}
//end

// Returns the appropriate currency placeholder based on the store region
export const getCurrencyPlaceholder=():"Amount" =>{
    
    // Decide currency placeholder based on the region code
    return 'Amount';
}
//end

export const getGSTByRegion=(value?:TProductType):number=>{
    if(!value) return 0
    return isStoreKuwaitRegion() ? (value.tax_rate ?? 0) : value?.gst_percentage
}

// function to change the currency
export const currencySymbol = (): "₹" | 'KWD' => {

    // Decide currency symbol based on the region code
    return isStoreKuwaitRegion() ? 'KWD' : '₹';
}
// end

// function to update the price according to region
export const priceTagFormatter = (rawPrice: number | string | undefined): string => {

    if (!rawPrice) return `${currencySymbol()} 0`
    // Trim the price if it's a string, then convert it to a number
    const parsedPrice = Number(typeof rawPrice === 'string' ? rawPrice.trim() : rawPrice);

    // Ensure two decimal places and format with commas
    const formattedPrice = numberWithCommas(Number(parsedPrice.toFixed(isStoreKuwaitRegion() ? 3 : 2)));

    // Return formatted price with currency and suffix
    return `${currencySymbol()} ${formattedPrice}${isStoreKuwaitRegion() ? '' : "/-"}`;
};
// end

// INFO:- Validates if the input is a number less than or equal to 100
export const isValidNumberInput = (value: string | null, numberLimit?: number): boolean => {
    //CRIT:- Allow empty or null values (optional input is considered valid)
    if (!value) return true;

    // Convert the input string to a number and check:
    return !isNaN(Number(value)) && Number(value) <= (numberLimit ?? 100);
};
// end

// INFO:- function to give mobile number code 
export const getCountryDialCode = (): CountryCodeReturnType => {
    return isStoreKuwaitRegion() ? constant.COUNTRY_CODES[1].code : constant.COUNTRY_CODES[0].code;
};
//end

//INFO:- function to show the GST or VAT according to region
export const getRegionTaxCode = (): typeof constant.TAX_CODES[keyof typeof constant.TAX_CODES] => {
    return isStoreKuwaitRegion() ? constant.TAX_CODES.VAT : constant.TAX_CODES.GST;
};
//end

//function to get the brand name region wise
export const regionWiseBrandName = (
    brandName: string | null,
    kuwaitBrandName: string | null
  ): string => {
    if (!brandName) return '';
    return isStoreKuwaitRegion() && kuwaitBrandName
      ? `${brandName} / ${kuwaitBrandName}`
      : brandName;
  };
// end

//function to make the drop down list for brand
export const getDropdownRegionWise = (response: [], name: string, kuwaitRegionKey:string) => {
    let dropdown: any = []
    response && response.map((value: any) => {
        dropdown.push({
            "value": value.id,
            "label": regionWiseBrandName(value[name], value[kuwaitRegionKey]),
            "code": value?.brand_code || '',
            "brand_category": value?.brand_category
        }
        )
    })
    return dropdown
}
//end

//for sidebar

//function to change the name of report
export const getSalesReportTitle=():string=>{
    return isRegularGstStore() ? "Sales Tax Report" : "Item Wise Sales Report"
}
//end

//end